export interface JwtToken {
    sub?: string;
    iss: string;
    exp: number;
    scopes: string[];
    issued: number;
    active2fa: number;
}
export enum TokenStatus {
    invalid,
    expired,
    valid,
}
export class Jwt {
    jwtString?: string;
    jwt?: JwtToken;
    status: TokenStatus;
    constructor(jwt?: string) {
        try {
            if (jwt) {
                this.jwt = parseJwt(jwt);
                this.jwtString = jwt;
            }
            this.status = this.checkToken();
        } catch (e) {
            this.status = TokenStatus.invalid;
        }
    }

    isExpired(withinSeconds = 30): boolean {
        return this.checkToken(withinSeconds) !== TokenStatus.valid;
    }

    is2FAExpired(): boolean {
        if (!this.jwt || this.jwt.active2fa === undefined) {
            return false;
        }
        return this.jwt.active2fa * 1000 <= new Date().getTime();
    }

    is2FAEnabled(): boolean {
        if (!this.jwt || this.jwt.active2fa === undefined) {
            return false;
        }
        return this.jwt.active2fa > 0;
    }

    checkToken(withinSeconds = 30): TokenStatus {
        let status: TokenStatus | undefined;
        if (!this.jwt) {
            status = TokenStatus.invalid;
        } else {
            const jwt = this.jwt;
            const tokenExpiresAt = +jwt.exp * 1000 - withinSeconds * 1000;
            const expiryLimit = new Date().getTime();
            status = tokenExpiresAt > expiryLimit ? TokenStatus.valid : TokenStatus.expired;
        }
        return status;
    }
}

export function parseJwt(token: string): JwtToken {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join(''),
    );

    return JSON.parse(jsonPayload);
}
